module.exports = __webpack_public_path__ + "static/michael-pollan-4033de8ca2ba40d1128b2b64cfc8b7be.jpg";